// v1.25.10版本
// @ts-ignore
import sensors from './libs/sensorsdata/sensorsdata.es6.min.js';
import WebStats from './WebStats';

const Stats = new WebStats();
Stats.sensors = sensors;

// 兼容1.0旧写法
// @ts-ignore
window.StatsSDK = { Stats };

// @ts-ignore
if (window.statsConfig) {
  // 如果是stats插件构建，会有statsConfig全局对象，进行自动初始化
  // @ts-ignore
  Stats.init(window.statsConfig);
}

export default Stats;

setTimeout(() => {
  // @ts-ignore
  if (!window.Stats) {
    // @ts-ignore
    window.Stats = Stats;
  }
}, 10);
